import React from 'react';

export interface Permissions {
  ui?: { [accessTo: string]: string[] };
  companies?: { [accessTo: string]: string[] };
}

export const PermissionsContext = React.createContext<Permissions>({});
